import { FormattedMessage } from 'react-intl'
import { mapValues } from 'lodash/fp'
import messages from '@flix/common/domain/video/messages'
import VideoPlayer from '../../../components/video/VideoPlayer/VideoPlayer'
import ErrorPage from '../../../containers/errors/ErrorPage/ErrorPage'

const VideoPlayerPage = ({ location, history }) => {
  const query = new URLSearchParams(location.search)

  if (!query.get('url')) {
    return (
      <ErrorPage>
        <FormattedMessage {...messages.videoNotFound} />
      </ErrorPage>
    )
  }

  const source = mapValues(window.decodeURIComponent, {
    title: query.get('title') || '',
    url: query.get('url') || '',
    mime: query.get('mime') || '',
  })
  return <VideoPlayer playlist={[source]} onRequestClose={history.goBack} />
}

export default VideoPlayerPage
